import React, { useEffect } from 'react'
import { Box, Stack, Text } from '@chakra-ui/react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { getCountryList } from '../../actions/countryActions'
import { TransferDetailsFields, TransferForm, CheckDetails } from '@Types'
import { CountryItem } from '../../reducers/types'
import { RootState } from '../../store'
import { formatAddress } from '../../utils'

export interface CheckDetailsProps {
  fields: TransferForm
  countryList: CountryItem[]
  getCountryList: () => void
}

function CancelTransferModalCheckDetailsComponent({ fields, countryList, getCountryList }: CheckDetailsProps) {
  const { transferDate } = fields
  const { transferType, transferAmount, checkDetails } = fields.transferDetails as TransferDetailsFields
  const { beneficiaryDetails, deliveryMethod } = checkDetails as CheckDetails

  const address = formatAddress(beneficiaryDetails?.addressDetails!, countryList)

  useEffect(() => {
    if (!countryList.length) {
      getCountryList()
    }
  }, [countryList, getCountryList])
  return (
    <Stack spacing='8'>
      <Stack direction='row' spacing='5'>
        <Box width={7.5 / 16}>
          <Text>Transfer Type</Text>
          <Text>{transferType.display}</Text>
        </Box>
        <Box width={7.5 / 16}>
          <Text>Transfer Amount</Text>
          <Text>{transferAmount.display}</Text>
        </Box>
      </Stack>
      <Stack direction='row' spacing='5'>
        <Box width={7.5 / 16}>
          <Text>Beneficiary Name</Text>
          <Text>{checkDetails?.beneficiaryDetails?.name}</Text>
        </Box>
        {address && (
          <Box>
            <Text>Address</Text>
            {address.streetAddress1 && <Text>{address.streetAddress1}</Text>}
            {address.streetAddress2 && <Text>{address.streetAddress2}</Text>}
            {address.city && address.hasComma && <Text>{`${address.city}, ${address.StateAndZip}`}</Text>}
            {address.city && !address.hasComma && <Text>{address.city}</Text>}
            {address.country && <Text>{address.country}</Text>}
          </Box>
        )}
      </Stack>
      <Box>
        <Text>Delivery Method</Text>
        <Text>{deliveryMethod}</Text>
      </Box>
      <Box>
        <Text>Transfer Date</Text>
        <Text>{transferDate}</Text>
      </Box>
    </Stack>
  )
}

const mapStateToProps = (state: RootState) => {
  const {
    countryReducer: { countryListLoading, countryList, countryListFailedMessage }
  } = state

  const countryAutoSelectDataSet = countryList
    .filter((country) => country.isoName)
    .map((country) => ({ value: country.isoName! }))

  return { countryListLoading, countryList, countryListFailedMessage, countryAutoSelectDataSet }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getCountryList: () => getCountryList(dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CancelTransferModalCheckDetailsComponent)
